import { render, staticRenderFns } from "./FincasB.vue?vue&type=template&id=2274cebf"
import script from "./FincasB.vue?vue&type=script&lang=js"
export * from "./FincasB.vue?vue&type=script&lang=js"
import style0 from "./FincasB.vue?vue&type=style&index=0&id=2274cebf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports